import React from 'react';
import { Modal, Button, ButtonContent, Icon } from 'semantic-ui-react';
import { INameSearchName } from './types';
import Row from './Components/Row';
import produce from 'immer';
import axios from 'axios';

export interface IProps {
  afterSubmit?: (names: INameSearchName[]) => void;
  names: INameSearchName[];
  searchId: number;
  searchTypeId: number;
}

const searchTypeDocumentMapper: { [key: string]: number } = {
  '36': 18,
  '35': 15,
  '90': 54,
  '38': 55,
};

export default function NameSearchUploadAttachments(props: IProps) {
  const [contacts, setContacts] = React.useState<INameSearchName[]>([]);
  const [disableBtn, setDisableBtn] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);

  React.useEffect(() => {
    setContacts(props.names);
  }, [props.names]);

  const afterDropFile = (contact: INameSearchName, files: any[]) => {
    const newContacts = produce(contacts, draft => {
      const index = draft.findIndex(c => c.id === contact.id);
      if (index > -1) {
        draft[index].documents = (draft[index].documents || []).concat(files);
      }
    });
    setContacts(newContacts);
  };

  const removeFileFromContact = (contact: INameSearchName, fileIndex: number) => {
    const newContacts = produce(contacts, draft => {
      const index = draft.findIndex(c => c.id === contact.id);
      if (index > -1) {
        draft[index].documents.splice(fileIndex, 1);
      }
    });
    setContacts(newContacts);
  };

  const handleSubmit = async () => {
    setDisableBtn(true);
    const documentTypeId = searchTypeDocumentMapper[props.searchTypeId.toString()];

    for (let contact of contacts) {
      if ((contact.documents || []).length === 0) {
        continue;
      }
      const obj = {
        documentTypeId,
        searchIds: [props.searchId],
        files: contact.documents,
        fileName: `${contact.name}.pdf`,
      };
      await axios.post('/api/orders/uploadSearchDocument', obj);
    }

    setDisableBtn(false);
    setModalOpen(false);
    if (props.afterSubmit) {
      const newContacts = contacts.map(c => ({
        ...c,
        uploadedDocuments: c.documents?.length > 0,
        documents: [] as any[],
      }));
      props.afterSubmit(newContacts);
    }
  };
  return (
    <div>
      {props.names.length > 0 && (
        <Button
          style={{ marginLeft: 16 }}
          animated="vertical"
          onClick={() => setModalOpen(true)}
        >
          <ButtonContent hidden>Upload</ButtonContent>
          <ButtonContent visible>
            <Icon name="upload" />
          </ButtonContent>
        </Button>
      )}
      {modalOpen && (
        <Modal open={modalOpen}>
          <Modal.Header style={{ textAlign: 'center' }}>Upload Attachments for Names</Modal.Header>
          <Modal.Content>
            <div style={{ flexDirection: 'column', display: 'flex', gap: 8 }}>
              {contacts.map((contact: INameSearchName) => (
                <Row
                  key={contact.id}
                  contact={contact}
                  removeFileFromContact={removeFileFromContact}
                  afterDropFile={afterDropFile}
                />
              ))}
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button className="ui button" onClick={() => setModalOpen(false)}>
              Close
            </Button>
            <Button
              disabled={disableBtn}
              loading={disableBtn}
              active
              onClick={handleSubmit}
              className="ui primary button"
            >
              Submit
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </div>
  );
}
